module.exports = __webpack_public_path__ + "assets/img/slogan-0e8f784b.png";